(ns common.widgets.full-screen-preview
  (:require ["@mui/material/DialogContent$default" :as DialogContent]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react-use/lib/useMeasure$default" :as useMeasure]
            [common.modal.view :refer [defmodal]]
            [common.widgets.pan-zoom :as pan-zoom]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]))

(def MIN-ZOOM 0.2)
(def MAX-ZOOM 10)
(def ZOOM-FACTOR 1.25)

(defmodal full-screen-preview ::full-screen-preview
  [{:keys [preview preview-width preview-height]}]
  (let [[measure-ref measure] (useMeasure)

        available-width (.-width measure)
        available-height (.-height measure)

        initial-scale (min (/ available-width preview-width)
                           (/ available-height preview-height)
                           1.0)

        [scale set-scale] (uix/use-state initial-scale)

        zoom (uix/use-callback (fn [down]
                                 (pan-zoom/update-zoom set-scale ZOOM-FACTOR MIN-ZOOM MAX-ZOOM down))
                               [])
        _zoom-control-ref (pan-zoom/use-zoom-control {:zoom zoom})

        [[x y] set-pos*] (uix/use-state [0 0])

        measured-w (.-width measure)
        measured-h (.-height measure)
        set-pos (uix/use-callback (fn [f]
                                    (pan-zoom/limited-set-pos set-pos* measured-w measured-h f))
                                  [measured-w measured-h])]

    (uix/use-effect (fn []
                      (set-scale initial-scale))
                    [initial-scale])
    ($ Stack
       {:backgroundColor "grey"
        :overflow "hidden"
        :sx #js {:width "90vw"
                 :maxWidth "100%"
                 :height "90vh"
                 :p 1}}
       ($ IconButton
          {:onMouseDown #(rf/dispatch [:modal/close])
           :sx #js {:flexShrink 0
                    :p 0
                    :alignSelf "end"
                    :color "white"}
           :data-testid "modal-close-button"}
          ($ Icon {:sx #js {:fontSize "3rem"}} "close"))
       ($ DialogContent
          {:ref measure-ref
           :sx #js {:background "unset"
                    :padding 0
                    :justifyItems "center"}}
          ($ pan-zoom/pan-area
             {:set-pos set-pos
              :style {:width "100%"
                      :height available-height}}
             ($ pan-zoom/pan-item
                {:scale scale
                 :style (pan-zoom/centered-item-style x y preview-width preview-height)}
                preview)))

       ($ Stack
          {:direction "row"
           :sx #js {:backgroundColor "#082040"
                    :color "white"
                    :position "sticky"
                    :alignSelf "center"
                    :alignItems "center"}}
          ($ IconButton
             {:onClick (fn [_]
                         (zoom true))
              :sx #js {:color "white"}}
             ($ Icon "remove"))

          ($ Typography
             {:sx (fn [_theme]
                    #js {:fontSize "lg"
                         :mx 0.5
                         :fontWeight 500
                         :minWidth "4.5rem"
                         :textAlign "center"})}
             (str (Math/round (* 100 scale)) "%"))

          ($ IconButton
             {:onClick (fn [_]
                         (zoom false))
              :sx #js {:color "white"}}
             ($ Icon "add"))))))
